export const ACTIONS = {
  CHANGE_MODE: 'changeMode',
  CHANGE_DEVICE: 'changeDevice',
  SHOW_ADD_PAGE: 'showAddPage',
  ADD_PAGE: 'addPage',
  CHANGE_VOICE: 'changeVoice',
  ELEMENT_SELECTED: 'elementSelected',
  ELEMENT_UNSELECTED: 'elementUnSelected',
  SELECTED_ELEMENT_UPDATED: 'selectedElementUpdated',
  ELEMENT_LOCKED: 'elementLocked',
  POPUPS_DETECTED: 'popupsDetected',
  HIDE_POPUPS: 'hidePopups',
  SAVE: 'save',
  SAVE_AS_NEW: 'saveAsNew',
  SELECT_PAGE: 'selectPage',
  SELECT_VERSION: 'selectVersion',
  UNDO: 'undo',
  REDO: 'redo',
  DIRTY_CHANGED: 'dirtyChanged',
  DISCARD: 'discard',
  CANCEL: 'cancel',
  SHOW_HISTORY: 'showHistory',
  STATUS_CHANGE: 'statusChange',
  GENERATE_FULL_PAGE: 'generateFullPage',
  AI_REPHRASE: 'aiRephrase',
  BACK: 'back',
  SET_SELECTED_EL_TEXT: 'setSelectedElText',
  SET_SELECTED_EL_HTML: 'setSelectedElHTML',
  SET_SELECTED_EL_ATTRIBUTE: 'setSelectedElAttribute',
  SET_SELECTED_EL_IMAGE: 'setSelectedElImage',
  PUBLISH: 'publish',
  TOGGLE_PAGES: 'togglePages',
  TOGGLE_VERSIONS: 'toggleVersions',
  TOGGLE_CONTROLS: 'toggleControls',
  SELECT_ELEMENT: 'selectElement',
  SELECT_FAILED_ELEMENT: 'selectFailedElement',
  ERROR_DETECTED: 'errorDetected',
  IMAGE_GENERATION_ERROR: 'imageGenerationError',
  TEXT_GENERATION_ERROR: 'textGenerationError',
  ERROR_MODAL_BACK: 'errorModalBack',
  DOWNLOAD_APP: 'downloadApp',
  TOGGLE_INTERACTIVE: 'toggleInteractive',
  SHOW_PUBLISH_STEPS: 'showPublishSteps',
  HIDE_PUBLISH_STEPS: 'hidePublishSteps',
  REPORT_ERROR: 'reportError',
  MARK_WINDOW_STALE: 'markWindowStale',
  APPROVE: 'approve',
  TRACK_METRIC: 'trackMetric',
  SET_SEGMENT: 'setSegment',
  SET_NEW_USER: 'setNewUser',
  SHOW_AUTH_MODAL: 'showAuthModal',
  RUN_CHECKS: 'runChecks',
  RUN_CHECKS_DEBOUNCED_FOR_ELEMENT: 'runChecksDebouncedForElement',
  RUN_CHECKS_FOR_ELEMENT: 'runChecksForElement',
  TOGGLE_BRANDCHECKSRESULTS: 'toggleBrandCheckResults',
  SAVE_CHECKS_RESULTS: 'saveChecksResults',
  BRAND_CHECKS_ERROR: 'brandChecksError',
  UPDATE_BRAND_GUIDELINES: 'updateBrandGuideLines',
  IGNORE_CHECKS: 'ignoreChecks',
  BACK_TO_CHECK_RESULTS: 'backToCheckResults',
};
